<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AllTree v-on:handleTreeClick="handleTreeClick"></AllTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
        <el-form-item label="系统名称" prop="systemname">
          <el-input v-model="payConfigure.systemname" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="支付宝APPID" prop="aliAppId">
          <el-input v-model="payConfigure.aliAppId" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="aliAppPartner">
          <el-input v-model="payConfigure.aliAppPartner" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="公钥" prop="alipayPublicKey">
          <el-input v-model="payConfigure.alipayPublicKey" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="私钥" prop="aliPrivateSign">
          <el-input v-model="payConfigure.aliPrivateSign" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <!-- <template v-if='payConfigure.openChildFlag'>
        <div class='child-configure'>子账户配置</div>
        <el-form-item label="PID" prop="appPid">
          <el-input v-model="payConfigure.appPid" @focus="isParkingIdEmpty" ></el-input>
        </el-form-item>
        <el-form-item label="应用id" prop="authAppId">
          <el-input v-model="payConfigure.authAppId" @focus="isParkingIdEmpty" ></el-input>
        </el-form-item>
        <el-form-item label="token有效时间" prop="expiresIn" >
          <el-input readonly v-model="payConfigure.expiresIn" @focus="isParkingIdEmpty" ></el-input>
        </el-form-item>
        <el-form-item label="token刷新时间" prop="reExpiresIn" >
          <el-input readonly v-model="payConfigure.reExpiresIn" @focus="isParkingIdEmpty" ></el-input>
        </el-form-item>
        </template>-->
        <el-form-item>
          <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          <!-- <el-checkbox v-model="payConfigure.openChildFlag" label="是否启用子商户" name></el-checkbox> -->
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { aliPayConfigureOne, aliPayConfigureAddOrEdit } from "@/api/url";

import AllTree from "@/page/commons/allTree";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      fileList: [],
      payConfigure: {
        id: "",
        systemname: "",
        aliAppId: "",
        aliAppPartner: "",
        aliPrivateSign: "",
        alipayPublicKey: "",
        openFlag: false,
        parkingId: "",
        // appPid:"",//子商户PID
        // authAppId:"",//子商户应用id
        // expiresIn:"",//子商户token有效时间
        // reExpiresIn:"",//子商户token刷新时间
        // appAuthToken:"",//子商户授权token
        // appRefreshToken:"",//子商户刷新token
        // openChildFlag:false,
      },
      rules: {
        systemname: [
          { required: true, message: "请填写系统名称", trigger: "blur" },
        ],
        aliAppId: [
          { required: true, message: "请填写支付宝APPID", trigger: "blur" },
        ],
        aliAppPartner: [
          { required: true, message: "请填写收款账号", trigger: "blur" },
        ],
        alipayPublicKey: [
          { required: true, message: "请填写公钥", trigger: "blur" },
        ],
        aliPrivateSign: [
          { required: true, message: "请填写私钥", trigger: "blur" },
        ],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.systemname = "";
        this.payConfigure.id = "";
        this.payConfigure.aliAppId = "";
        this.payConfigure.aliAppPartner = "";
        this.payConfigure.aliPrivateSign = "";
        this.payConfigure.alipayPublicKey = "";
        this.payConfigure.openFlag = false;
        // this.$message({
        //     message: '请选择车场！',
        //     type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(aliPayConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          this.payConfigure.systemname = data.data.systemname;
          this.payConfigure.id = data.data.id;
          this.payConfigure.aliAppId = data.data.aliAppId;
          this.payConfigure.aliAppPartner = data.data.aliAppPartner;
          this.payConfigure.aliPrivateSign = data.data.aliPrivateSign;
          this.payConfigure.alipayPublicKey = data.data.alipayPublicKey;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          this.payConfigure.systemname = "";
          this.payConfigure.id = "";
          this.payConfigure.aliAppId = "";
          this.payConfigure.aliAppPartner = "";
          this.payConfigure.aliPrivateSign = "";
          this.payConfigure.alipayPublicKey = "";
          this.payConfigure.openFlag = false;
        }
      });
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(aliPayConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,
            systemname: this.payConfigure.systemname,
            aliAppId: this.payConfigure.aliAppId,
            aliAppPartner: this.payConfigure.aliAppPartner,
            alipayPublicKey: this.payConfigure.alipayPublicKey,
            aliPrivateSign: this.payConfigure.aliPrivateSign,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return this.$layer.msg(data.message);
            this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
        }
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AllTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}
/* .child-configure{
  border-bottom:1px solid #278CD8;
  padding-bottom:10px;
  margin-bottom:20px;
  color:#278CD8;
  font-size:18px;
  font-weight: bold;
} */
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>